var map = {
	"./assets/thewest-digital-hero-cropped.jpg": 680,
	"./assets/thewest-digital-hero-variation-a-cropped.jpg": 472,
	"./assets/thewest-digital-hero-variation-a.jpg": 681,
	"./assets/thewest-digital-hero-variation-b-cropped.jpg": 682,
	"./assets/thewest-digital-hero-variation-b.jpg": 2576,
	"./assets/thewest-digital-hero-variation-black-friday-cropped.jpg": 683,
	"./assets/thewest-digital-hero-variation-black-friday.jpg": 2577,
	"./assets/thewest-digital-hero-variation-experiment2-cropped.jpg": 684,
	"./assets/thewest-digital-hero-variation-experiment2.jpg": 2578,
	"./assets/thewest-digital-hero-variation-vanishing-cousins-cropped.jpg": 685,
	"./assets/thewest-digital-hero-variation-vanishing-cousins.jpg": 2579,
	"./assets/thewest-digital-hero.jpg": 2580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2575;